/*
 *
 * Attendance constants
 *
 */

export const LOAD_COURSES = 'app/Attendance/LOAD_COURSES';
export const LOAD_COURSES_SUCCESS = 'app/Attendance/LOAD_COURSES_SUCCESS';
export const LOAD_COURSES_ERROR = 'app/Attendance/LOAD_COURSES_ERROR';

// DELETE
/* export const DELETE_ATTENDANCE = 'app/Attendance/DELETE_ATTENDANCE';
export const DELETE_ATTENDANCE_SUCCESS =
  'app/Attendance/DELETE_ATTENDANCE_SUCCESS';
export const DELETE_ATTENDANCE_ERROR = 'app/Attendance/DELETE_ATTENDANCE_ERROR'; */

export const FLUSH_STATE_ATTENDANCE = 'app/Attendance/FLUSH_STATE_ATTENDANCE';
